import { ISetting, ISettingDownloadService } from '../_types/interfaces';


const getSettings = async (): Promise<ISetting> => {
    return new Promise<ISetting>(resolve => setTimeout(() => resolve({
         TimeSleap: "4",
         TypeTime: "час",
         OfflineInstall: true,
         ServerAddress: "http://84.201.169.119:18080"
    }), 1000));
};

const updateSettings = async (setting: ISetting): Promise<void> => {
    return console.log(setting);
};

export const fakeSettingService: ISettingDownloadService = {
    getSettings,
    updateSettings,
};